import React, { Component } from 'react'; 
import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, withStyles, TextField, MenuItem, Grid, Divider,
Table, TableBody, TableCell, Checkbox, TableRow, TablePagination, TableHead, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { AssignmentInd, AssignmentLate, AssignmentTurnedIn } from '@material-ui/icons';
import creds from '../config/firebaseConfig';
import db from '../config/firestoreConfig';


const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        position: 'relative',
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        margin: 'auto',
        width: '75%',
        overflowX: 'auto'
    },
    container: {
        display: 'block',
        flexWrap: 'wrap',
        width: '100%',
        padding: 10,
        margin: 'auto',
        alignItems: 'center',
        alignContent: 'center',
        overflowX: 'auto'
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 350,
        padding: 5,
    },
    button: {
        margin: theme.spacing.unit,
        width: 250,
        textAlign: 'left'
    },
    button2: {
        margin: 'auto',
        width: 250,
        textAlign: 'left'
    },
    iconButton: {
        width: '100%', 
        alignContent: 'center', 
        alignItems: 'center', 
        textAlign: 'center'
    }
})

let id = 0;


class viewStudents extends Component{
    constructor(props){
        super(props)
        this.state = {
            selected: [], 
            selectedUser : {
                displayName : '',
                password: '',
                email: '',
                accountType: '',
                UID: '',
            },
            newUser : {

            },
            rowsPerPage : 10,
            page : 0,
            searchPhrase : '',
            checkedList : [],
            open: false,
            abilityArr : ['Beginner', 'Intermediate', 'Advanced'],
            levelsArr: [] ,
            taskList: [],
            icons: [],
            subjectsToView: []
        }
        
    }

    componentDidMount(){
        var userlist = []
        var levels = [] 
        var output = []
        this.fetchTasks()
        db.collection('Users').where('accountType', '==', 'Student').get()
        .then( snapshot => { 
            snapshot.forEach( doc => { 
                userlist.push(doc.data())
            })
            console.log(userlist)
            this.setState({
                ...this.state,
                userlist: userlist,
            })
        })
        db.collection('Level').get()
        .then( snapshot => {
            snapshot.forEach(Lvl => {
                var subjyrs = []
                var ll = [] 
                levels.push(Lvl.id)
                db.collection('Level').doc(Lvl.id).collection('Subjects').get()
                .then( snapshot => { 
                    snapshot.forEach( subj => {
                        db.collection('Level').doc(Lvl.id).collection('Subjects').doc(subj.id).collection('Years').get()
                        .then(snapshot => { 
                            snapshot.forEach( yr => { 
                                console.log('ID', yr, yr.id)
                                subjyrs.push(yr.id)
                            })
                            console.log('SUBJYRS', subjyrs)
                            ll.push(subjyrs)
                        })
                    })
                    
                })
                output.push(ll)
            })
            
        })
        this.setState({
            ...this.state,
            levelsArr : levels,
            ll : output 
        })
    }

     fetchTasks = async () => { 
         var output = []
         var ref = await db.collection('AssignedTasks')
         var snapshot = ref.get()
         ref.get()
         .then(snapshot => {
             snapshot.forEach(task => { 
                 output.push({title: task.id, data: task.data()})
             })
            })
        
         console.log('TASKS', output, this.state.userlist)
         this.setState({
             ...this.state,
             taskList: output
         })
    }
    


    createData(name, accountType, currentLvl, year, email, uid) {
        id += 1;
        return {id, name, accountType, currentLvl, year, email, uid }; 
    }

    //ITEMS FOR THE TABLE   
    rows = (arr) => {
        const output = []
        console.log(arr);
        arr.map(record => {
            output.push(
                this.createData(record.displayName, record.accountType, record.CurrentLevel, record.CurrentYear, record.email, record.UID)
            )
        })
        return output
    }

    searchArr = (arr, searchTerm ) => {
        // console.log(searchTerm)
        searchTerm = searchTerm.toLowerCase()
        var output = [];
        arr.forEach(e => {
            if (e.name.toLowerCase().search(searchTerm) != -1) {
                output.push(e)
            }
        })
        return output
    }

    checked = (name) => event => {
        // console.log(this.state, event.target.value)
        var arr = this.state.checkedList;
        console.log(arr)
        const index = arr.indexOf(event.target.value)
        var index2
        this.state.userlist.forEach(user => { 
            if (user.UID == event.target.value) {
                // console.log('USER', user)
                return index2 = this.state.userlist.indexOf(user)
            }
        })
        // console.log('INDEX', index2, this.state.userlist[index2], arr[0])
        var thisUser = this.state.userlist[index2]
        console.log(index)
        if  (index != -1) {
            arr.splice(index, 1)
        } else {
            if (arr.length < 1) {
                arr.push(event.target.value)
            } else {
                window.alert('You may only edit 1 record at a time') //leftover code from old use of component
            }
        }

        this.getSubjects(thisUser)
        // console.log(arr)
        this.setState({
            ...this.state,
            checkedList: arr,
            open: true,
            selectedUser: thisUser,
            displayName: name
        }, () =>{console.log('204', this.state)})
        // console.log(this.state.checkedList)
        // console.log(this.state)
        this.evaluate(arr[0])

    }

    getSubjects = async (userObj) => { 
        console.log('USER', userObj)
        var level = userObj.CurrentLevel
        var output = [] 

        var subjects = await db.collection('Level').doc(level).collection('Subjects').get()
        subjects.forEach( subj => { 
            output.push(subj.id)
        })

        this.setState({
            ...this.state,
            subjectsToView: output
        })
    }

    checkedAll = () => {
        console.log(this.makeTableData())
    }

    handleChange = name => event => {
        this.setState({
            ...this.state,
            [name]: event.target.value
        })
    }

    makeTableData = () => {
        return this.searchArr(this.rows(this.state.userlist), this.state.searchPhrase)
        
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleClose = () => { 
        this.setState({
            ...this.state,
            open: false,
            checkedList: [],
            subjectToView: '',
            displayName: ''
        })
    }

    evaluate = uid => { 
        console.log(this.state)
        // console.log('TITLE', title, this.state.tasks)
        var output = []
        var myTasks = []
        var taskList = this.state.taskList
        this.setState({
            icons: []
        })
        taskList.forEach(task =>{ 
            var length = myTasks.length
            // console.log(task)
            if (task.data){
                task.data.AssignedTo.forEach(student =>{ 
                    if (student.Student == uid && myTasks.indexOf(task) == -1){
                        myTasks.push({title: task.title, data: student, subject: task.data.Subject})
                    } 
                })
                if (length == myTasks.length){
                    output.push({title: task.title, iconValue: 0})
                }
            }
        })
        console.log('TASKS' , myTasks, taskList)
        myTasks.forEach(task  => {
            var punctuality = task.data.punctuality
            if (punctuality){
                console.log('PUNCTUALITY', punctuality)
                if (punctuality > 0){
                    output.push({title: task.title, iconValue: 3, score: task.data.Score, subject: task.subject})
                } else {
                    output.push({title: task.title, iconValue: 2, score: task.data.Score, subject: task.subject})
                }
            } else {
                var testDeadline 
                taskList.forEach( test => {
                    if (test.title == task.title){
                        return testDeadline = test.data.Deadline 
                    }
                })
                console.log('deadline', testDeadline)
                if (new Date(testDeadline).valueOf() > new Date().valueOf()){
                    //push an assigned icon
                    output.push({title: task.title, iconValue: 1, score: task.data.Score, subject: task.subject})
                } else {
                    //push a late icon
                    output.push({title: task.title, iconValue: 2, score: task.data.Score, subject: task.subject})
                }
            } 
        })
        this.setState({
            ...this.state,
            icons: output,
            open: true
        }, ()=>{console.log('302', this.state.icons)})
        
        //         console.log('DATA', doc.data())
        //         var deadline = new Date(doc.data().Deadline).valueOf()
        //         console.log(deadline)
        //         doc.data().AssignedTo.forEach(s => { 
        //             if (s.Student == uid){
        //                 if (s.CompletionDate == 'N/A'){
        //                     if (deadline < new Date().valueOf()){
        //                         output.push(1)
        //                         console.log('OUTPUT', output, doc.id)
        //                         var final = {title: doc.id, value: 1}
        //                         console.log('FINAL', final)
        //                         var add = true
        //                         this.state.icons.forEach(icon => { 
        //                             if (icon.title == doc.id){
        //                                 console.log('ALREADY EXISTS', icon.title, doc.id, this.state.icons)
        //                                 add = false
        //                             }
        //                         })
        //                         if (add) {
        //                             console.log('WE PUSHIN')
        //                             var toSet = this.state.icons
        //                             toSet.push(final)
        //                             this.setState({
        //                                 ...this.state,
        //                                 icons : toSet
        //                             })
        //                         }
        //                     } else {
        //                         output.push(2)
        //                         console.log('OUTPUT', output, doc.id)
        //                         var final = {title: doc.id, value: 2}
        //                         console.log('FINAL', final)
        //                         var add = true
        //                         this.state.icons.forEach(icon => { 
        //                             if (icon.title == doc.id){
        //                                 console.log('ALREADY EXISTS', icon.title, doc.id, this.state.icons)
        //                                 add = false
        //                             }
        //                         })
        //                         if (add) {
        //                             console.log('WE PUSHIN')
        //                             var toSet = this.state.icons
        //                             toSet.push(final)
        //                             this.setState({
        //                                 ...this.state,
        //                                 icons : toSet
        //                             })
        //                         }
        //                     }
        //                 } else
        //                 if (new Date(s.CompletionDate).valueOf() <  deadline){
        //                     console.log('ONTIME')
        //                     output.push(3)
        //                     console.log('OUTPUT', output, doc.id)
        //                     var final = {title: doc.id, value: 3}
        //                     console.log('FINAL', final)
        //                     var add = true
        //                     this.state.icons.forEach(icon => { 
        //                         if (icon.title == doc.id){
        //                             console.log('ALREADY EXISTS', icon.title, doc.id, this.state.icons)
        //                             add = false
        //                         }
        //                     })
        //                     if (add) {
        //                         console.log('WE PUSHIN')
        //                         var toSet = this.state.icons
        //                         toSet.push(final)
        //                         this.setState({
        //                             ...this.state,
        //                             icons : toSet
        //                         })
        //                     }
        //                 } else {
        //                     console.log('LATE')
        //                     output.push(1)
        //                     console.log('OUTPUT', output, doc.id)
        //                     var final = {title: doc.id, value: 1}
        //                     console.log('FINAL', final)
        //                     var add = true
        //                     this.state.icons.forEach(icon => { 
        //                         if (icon.title == doc.id){
        //                             console.log('ALREADY EXISTS', icon.title, doc.id, this.state.icons)
        //                             add = false
        //                         }
        //                     })
        //                     if (add) {
        //                         console.log('WE PUSHIN')
        //                         var toSet = this.state.icons
        //                         toSet.push(final)
        //                         this.setState({
        //                             ...this.state,
        //                             icons : toSet
        //                         })
                                
        //                     }
        //                 }
        //             }
        //         })
        //     }
        // }.bind(this))
        // console.log('FINAL PLEASE', output, this.state)
    }

    render(){
        const { classes } = this.props;
        return (
            <div>
                {(this.state.userlist ? 
                    <Paper className={classes.root} elevation={1}>
                            <Typography variant='headline'>
                                View task list for students
                                
                            </Typography>
                                
                            <Divider/>
                            
                        <br/>
                            <div style={{ overflow: 'hidden', zoom: 1 }}>
                                <TextField className={classes.TextField}
                                    onChange={this.handleChange('searchPhrase')}
                                    value={this.state.searchPhrase}
                                    helperText='Search for Students via dislay name'
                                />
                                <Typography variant='subheading' style={{ display: 'inline-block', right: 0, float: 'right', alignContent: 'center'}}>
                                    Key for task status: <br/> <AssignmentInd/>   Set <br/> <AssignmentLate/>   Late <br/> <AssignmentTurnedIn/>   Completed
                                </Typography>
                            </div>
                            <br/>
                            <Paper>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell><Checkbox disabled={true}/></TableCell>
                                        <TableCell>User</TableCell>
                                        <TableCell>Account Type</TableCell>
                                        <TableCell>Current Level</TableCell>
                                        <TableCell>Current Year</TableCell>
                                        <TableCell>Email</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.makeTableData()
                                        .slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                                        .map(row => {
                                        return (
                                            
                                            <TableRow 
                                                key={row.id}
                                                hover
                                                tabIndex={-1}>
                                                <TableCell><Checkbox  value={row.uid} onChange={this.checked(row.name)} checked={(this.state.checkedList.indexOf(row.uid) != -1)}/></TableCell>
                                                <TableCell component="th" scope="row">
                                                {row.name}
                                                </TableCell>
                                                <TableCell>{row.accountType}</TableCell>
                                                <TableCell>{row.currentLvl}</TableCell>
                                                <TableCell>{row.year}</TableCell>
                                                <TableCell>{row.email}</TableCell>
                                                
                                            </TableRow>
                                            
                                        )
                                    })}
                                 </TableBody>   
                            </Table>
                            <TablePagination
                                component='div'
                                count={this.makeTableData().length}
                                rowsPerPage={this.state.rowsPerPage}
                                page={this.state.page}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                  }}
                                  nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                  }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                  />
                                  </Paper>
                                <br/>
                    </Paper>
                :
                
                <div/>)}
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                    maxWidth='lg'
                    minWidth='md'
                >
                    <DialogTitle id="form-dialog-title"> Student Progress </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Student progress through assigned tasks
                        </DialogContentText>
                        <Divider/>
                        <br/>
                        <TextField className={classes.textField}
                            select
                            value={this.state.subjectToView}
                            onChange={this.handleChange('subjectToView')}
                            helperText='Select a subject to view'
                        >
                            {this.state.subjectsToView.map( subject => (
                                <MenuItem value={subject} key={this.state.subjectsToView.indexOf(subject)}>
                                    {subject}
                                </MenuItem>
                            ))}
                        </TextField>
                        <br/>
                        <br/>
                        {this.state.subjectToView ? 
                                this.state.icons.map(icon => { 
                                    
                                    

                                    if (icon.iconValue == 1 && icon.subject == this.state.subjectToView){
                                        return (
                                            <div className={classes.iconButton}>
                                                <Button variant='outlined' className={classes.button}>
                                                    <div style={{width: '100%'}}>
                                                        {icon.title}
                                                        <AssignmentInd style={{float: 'right', alignSelf: 'right', alignContent: 'right'}}/>
                                                    </div>
                                                </Button>
                                                
                                                <br/>
                                                <br/>
                                            </div>
                                        )
                                    } else
                                    if (icon.iconValue == 2 && icon.subject == this.state.subjectToView){
                                        return (
                                            <div className={classes.iconButton}>
                                                <Button variant='outlined' className={classes.button}>
                                                    <div style={{width: '100%'}}>
                                                        {icon.title}
                                                        <AssignmentLate style={{float: 'right', alignSelf: 'right', alignContent: 'right'}}/>
                                                    </div>
                                                </Button>
                                                
                                                <br/>
                                                <br/>
                                            </div>
                                        )
                                    } else 
                                    if (icon.iconValue == 3 && icon.subject == this.state.subjectToView){
                                        return (
                                            <div className={classes.iconButton}>
                                                    <Button variant='outlined' className={classes.button2}>
                                                        <div style={{width: '100%'}}>
                                                            {icon.title}
                                                            <AssignmentTurnedIn style={{float: 'right', alignSelf: 'right', alignContent: 'right'}}/>
                                                        </div>
                                                    </Button>
                                                    <Typography variant='body2'>
                                                            <strong> Result {icon.score}% </strong>
                                                    </Typography>
                                                <br/>
                                            </div>
                                        )
                                    }
                            })
                    
                    
                        :
                            <div>
                                <Typography variant='caption'>No Data to show</Typography>
                            </div>
                        
                        }
                            
                        </DialogContent>
                </Dialog>
            </div>
        )
    }
}
export default withStyles(styles)(viewStudents);


// WEBPACK FOOTER //
// ./src/admin/viewStudents.jsx